import { render, staticRenderFns } from "./subproperty-requirement-steps.vue?vue&type=template&id=065ab2c9&scoped=true&"
import script from "./subproperty-requirement-steps.vue?vue&type=script&lang=js&"
export * from "./subproperty-requirement-steps.vue?vue&type=script&lang=js&"
import style0 from "./subproperty-requirement-steps.vue?vue&type=style&index=0&id=065ab2c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ab2c9",
  null
  
)

export default component.exports